import { render, staticRenderFns } from "./depositBatchNotify.vue?vue&type=template&id=3fbc8ad1&scoped=true"
import script from "./depositBatchNotify.vue?vue&type=script&lang=ts"
export * from "./depositBatchNotify.vue?vue&type=script&lang=ts"
import style0 from "./depositBatchNotify.vue?vue&type=style&index=0&id=3fbc8ad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc8ad1",
  null
  
)

export default component.exports